import { getRequest } from '@/core';
import { vendors } from '@/requests';

export default async function getVendorByNumberRequest(vendorNumber) {
	let url = vendors.getByNumberPath(vendorNumber);
	return getRequest(url);
}
